import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-download",
  "use": "foquz-icon-download-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" id=\"foquz-icon-download\"><path d=\"M15 10.333v2.593c0 .55-.182 1.078-.506 1.466-.324.39-.764.608-1.222.608H2.728c-.458 0-.898-.219-1.222-.607A2.301 2.301 0 011 12.925v-2.593M12 6.25L8 10 4 6.25m4 3V1\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol